module.exports = __webpack_public_path__ + "img/img_swim_app2_en.f396e406.png";